import { FeedbackQuestion } from "../../../models/Task";
import { Box, Flex, Heading } from "@radix-ui/themes";
import React, { useState } from "react";
import {
  FaRegSadTear,
  FaAngry,
  FaFrown,
  FaMeh,
  FaRegSurprise,
  FaSmile,
} from "react-icons/fa";
import Icon from "../../../assets/icons";

type Emotion = "cry" | "upset" | "neutral" | "happy" | "smile";

interface EmotionRatingProps {
  element: FeedbackQuestion;
  onChange: (emotion: Emotion) => void;
}

const EmotionRating: React.FC<EmotionRatingProps> = ({ onChange, element }) => {
  const [selectedEmotion, setSelectedEmotion] = useState<string | undefined>(
    element.answer
  );

  const handleEmotionChange = (emotion: Emotion) => {
    setSelectedEmotion(emotion);
    onChange(emotion);
  };

  return (
    <Box>
      <Heading>{element.question}</Heading>
      <Flex gap="3">
        <Box className="flex hover:scale-110 flex-col items-center">
          <button onClick={() => handleEmotionChange("cry")}>
            <img
              src={selectedEmotion === "cry" ? Icon.cryEmojiFilled : Icon.cryEmoji}
              alt="Cry Emoji"
            />
          </button>
        </Box>
        <Box className="flex hover:scale-110 flex-col items-center">
          <button onClick={() => handleEmotionChange("upset")}>
            <img
              src={selectedEmotion === "upset" ? Icon.upsetEmojiFilled : Icon.upsetEmoji}
              alt="Upset Emoji"
            />
          </button>
        </Box>

        <Box className="flex hover:scale-110 flex-col items-center">
          <button onClick={() => handleEmotionChange("neutral")}>
            <img
              src={
                selectedEmotion === "neutral"
                  ? Icon.neautralEmojiFilled
                  : Icon.neautralEmoji
              }
              alt="Neutral Emoji"
            />
          </button>
        </Box>

        <Box className="flex hover:scale-110 flex-col items-center">
          <button onClick={() => handleEmotionChange("happy")}>
            <img
              src={
                selectedEmotion === "happy"
                  ? Icon.happyEmojiFilled
                  : Icon.happyEmoji
              }
              alt="Happy Emoji"
            />
          </button>
        </Box>

        <Box className="flex hover:scale-110 flex-col items-center">
          <button onClick={() => handleEmotionChange("smile")}>
            <img
              src={
                selectedEmotion === "smile"
                  ? Icon.smileEmojiFilled
                  : Icon.smileEmoji
              }
              alt="Smile Emoji"
            />
          </button>
        </Box>

      </Flex>
    </Box>
  );
};

export default EmotionRating;
